module.exports = __webpack_public_path__ + "img/icons-fill-integrations-saphhire.a11f3ba2.svg";